import { render, staticRenderFns } from "./Web-design.vue?vue&type=template&id=02813b1a&scoped=true&"
import script from "./Web-design.vue?vue&type=script&lang=js&"
export * from "./Web-design.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02813b1a",
  null
  
)

export default component.exports